export default {
  'About': {
    'link': '/about'
  },
  'Teaching': {
    'link': '/teaching'
  }/*,
  'Projects': {
    'link': '/projects'
  }*/
};